// extracted by css-extract-rspack-plugin
export default {"menu":"PartnerModuleMenu_menu__+1WBN"};